import {useNavigate} from 'react-router-dom';
import React, {useEffect, useState, useContext} from 'react';
import {RiEyeLine, RiEyeOffLine} from 'react-icons/ri';
import {LuTrash} from 'react-icons/lu';
import {ParserDateTime} from '../../helper/dateFormatHandler';
import {getNotificationMessage} from '../../helper/getNotificationMessage';
import {getNotificationLink} from '../../helper/getNotificationLink';
import {
    APINotificationsToggle,
    APINotificationsDelete,
    APINotificationsReadAll,
    APINotidicationDeleteAll,
} from '../../api/notifications/Notifications';
import {GetNotificationIcon} from './getNotificationIcon';
import {UserContext} from '../../context/UserContext';

export const NotificationList = ({ notifications }) => {
    const {user, updateNotificationCount} = useContext(UserContext);
    const [localNotifications, setLocalNotifications] = useState(notifications);

    const navigate = useNavigate();

    const handleToggleRead = async (id) => {
        setLocalNotifications((prevNotifications) =>
            prevNotifications.map((notification) =>
                notification.id === id
                    ? {...notification, read: !notification.read}
                    : notification
            )
        );
        await APINotificationsToggle(id,user?.id);
        updateNotificationCount();
    };

    const handleReadAll = async () => {
        setLocalNotifications((prevNotifications) =>
            prevNotifications.map((notification) => ({
                ...notification,
                read: true,
            }))
        );
        await APINotificationsReadAll(user?.id);
        updateNotificationCount();
    };

    const handleDelete = async (id) => {
        setLocalNotifications((prevNotifications) =>
            prevNotifications.filter((notification) => notification.id !== id)
        );
        await APINotificationsDelete(id,user?.id);
        updateNotificationCount();
    };

    const handleDeleteAll = async () => {
        await APINotidicationDeleteAll(user?.id);
        setLocalNotifications([]);
        updateNotificationCount();
    };

    // TODO: Implement search functionality
    // const filterListBySearch = (search) => {
    //     let newResultList = [];
    //     for (let notification of notifications) {
    //         if (
    //             notification?.details.title
    //                 ?.toLowerCase()
    //                 ?.includes(search?.target?.value?.toLowerCase()) === true
    //         ) {
    //             newResultList?.push(notification);
    //         }
    //     }
    //     setLocalNotifications(newResultList);
    //     updateNotificationCount();
    // };

    useEffect(() => {
        setLocalNotifications(notifications);
    }, [notifications]);

    return (
        <div className='mx-auto w-full sm:max-w-7xl'>
            <div
                className={
                    'text-base m-5 mt-[30px] mb-12 leading-7 text-gray-600'
                }>
                <div className='mt-2 flex flex-col sm:flex-row items-center sm:justify-between'>
                    <div className='min-w-0 flex flex-1'>
                        <h2 className='w-full text-xl truncate sm:mb-0 mb-4 lg:text-2xl textShadow flex font-normal leading-7 text-gray-900 sm:truncate  sm:tracking-tight'>
                            Benachrichtigungen{' '}
                        </h2>
                    </div>
                    <div className='flex flex-shrink-0 justify-end md:ml-4 md:mt-0 gap-5'>
                        <button
                            className={
                                'gap-2 truncate inline-flex items-center rounded-md bg-white border border-gray-900 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                            }
                            onClick={() => {
                                handleReadAll();
                            }}>
                            <span className='sr-only'>Alle ausblenden</span>
                            <RiEyeOffLine
                                className='h-5 w-5'
                                aria-hidden='true'
                            />
                            <span className='hidden lg:block'>Alle ausblenden</span>
                        </button>
                        <button
                            className={
                                'hover:bg-red gap-2 truncate inline-flex items-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                            }
                            onClick={() => {
                                handleDeleteAll();
                            }}>
                            <span className='sr-only'>Alle loeschen</span>
                            <LuTrash
                                className='h-5 w-5'
                                aria-hidden='true'
                            />
                            <span className='hidden lg:block'>Alle löschen</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className={'border border-gray-500 rounded-lg  w-full bg-white mb-12'}>


                <div className='gap-3  divide-y divide-gray-300 '>

                    <div className="p-4 lg:p-6">
                        <h3 className="text-lg font-semibold text-gray-900">Neuste Nachrichten</h3>
                        <p className="mt-1 text-sm/6 text-gray-600/60">Hier finden Sie eine Übersicht aller Fortschritts-Updates Ihrer Aufträge.</p>
                    </div>

                    {localNotifications?.map(
                        (notification, key) => (
                            <div
                                key={key}
                                style={{
                                    gridTemplateColumns:
                                        'calc(100% - 89px) 65px',
                                }}
                                className={
                                    notification?.read === true
                                        ? 'text-gray-600/60 grid grid-cols-2   lg:px-6  px-4 py-4 justify-between cursor-pointer hover:bg-gray-200 hover:rounded'
                                        : 'text-gray-900 grid grid-cols-2   lg:px-6 px-4  py-4 justify-between cursor-pointer hover:bg-gray-200 hover:rounded'
                                }>
                                <div className={'px-4 py-2 w-full flex overflow-hidden'}
                                    onClick={() => {
                                        if ( notification?.read === false ) { handleToggleRead( notification?.id  );}
                                        navigate(getNotificationLink(notification));
                                    }}>

                                    {GetNotificationIcon(
                                        notification.type
                                    )}
                                    <div>
                                        <div
                                            className={'truncate  text-sm font-semibold flex-row mr-3 items-center'}>
                                            {getNotificationMessage( notification)}
                                        </div>

                                        <div className={'text-xs hidden w-full lg:flex text-gray-600/60 gap-4'}>
                                            <div className={ 'flex gap-1 items-center' }>
                                                Erstellt: {ParserDateTime( notification?.createdAt)}
                                            </div>
                                            {notification?.read ? (<div className={'flex gap-1 items-center'}>Status: Gelesen</div>) : (<div className={'flex gap-2 items-center'}>Status: Ungelesen </div>)}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={
                                        'w-[65px]  flex flex-row items-center justify-end'
                                    }>
                                    {notification?.read === true ? (
                                        <div
                                            className='cursor-pointer text-gray-900 rounded  p-2 m-2 ring-1 ring-gray-500 '
                                            onClick={() => {
                                                handleToggleRead(
                                                    notification?.id
                                                );
                                            }}>
                                            <RiEyeOffLine className='h-4 w-4'/>
                                        </div>
                                    ) : (
                                        <div
                                            className='cursor-pointer text-gray-900 rounded  p-2 m-2 ring-1 ring-gray-500 '
                                            onClick={() => {
                                                handleToggleRead(
                                                    notification?.id
                                                );
                                            }}>
                                            <RiEyeLine className='h-4 w-4'/>
                                        </div>
                                    )}
                                    <div
                                        className='cursor-pointer text-gray-900 rounded  p-2 m-2 ring-1 ring-gray-500 '
                                        onClick={() => {
                                            handleDelete(
                                                notification?.id
                                            );
                                        }}>
                                        <LuTrash className='h-4 w-4'/>
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>

        </div>
    );
};
